import Atalanta1 from '../../media/Atalanta/atalanta (1).png'
import Atalanta2 from '../../media/Atalanta/atalanta (2).png'
import Atalanta3 from '../../media/Atalanta/atalanta (3).png'
import Atalanta4 from '../../media/Atalanta/atalanta (4).png'
import Atalanta5 from '../../media/Atalanta/atalanta (5).png'
import Atalanta6 from '../../media/Atalanta/atalanta (6).png'
import Atalanta7 from '../../media/Atalanta/atalanta (7).png'
import Atalanta8 from '../../media/Atalanta/atalanta (8).png'
import Atalanta9 from '../../media/Atalanta/atalanta (9).png'
import Atalanta10 from '../../media/Atalanta/atalanta (10).png'
import Atalanta11 from '../../media/Atalanta/atalanta (11).png'
import Atalanta12 from '../../media/Atalanta/atalanta (12).png'
import Atalanta13 from '../../media/Atalanta/atalanta (13).png'

const images =[
    Atalanta1,Atalanta2,Atalanta3,Atalanta4,Atalanta5,Atalanta6,Atalanta7,Atalanta8,Atalanta9,Atalanta10,Atalanta11,Atalanta12,Atalanta13
]

export default images;